var map = {
	"./Aisha-Khan.PNG": 992,
	"./Asma-Begum.PNG": 912,
	"./David-Anderson.PNG": 944,
	"./Emily-Kim.PNG": 534,
	"./Irfan-Qureshi.PNG": 267,
	"./Mark-Robinson.PNG": 833,
	"./Nazia-Shaikh.PNG": 609
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 804;